export const resultImageSize = ['4.5rem', null, '6.75rem', '9rem']

// All Materials view modes
export const listView = 'list'
export const compactView = 'compact'

// Hit descriptions
export const descriptionCharLimitDefault = 90
export const descriptionCharLimitMd = 180
